const CHECKOUT_INTENT_KEY = 'checkoutIntent';

export function newCheckoutIntent() {
    return window.crypto?.randomUUID
        ? window.crypto.randomUUID()
        : Date.now().toString(36) + Math.random().toString(36).slice(2);
}

export function checkoutIntentFor($el) {
    if (!$el.data(CHECKOUT_INTENT_KEY)) {
        $el.data(CHECKOUT_INTENT_KEY, newCheckoutIntent());
    }

    return $el.data(CHECKOUT_INTENT_KEY);
}

export function clearCheckoutIntent($el) {
    $el.removeData(CHECKOUT_INTENT_KEY);
}
